import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress
} from '@mui/material';
import { green } from '@mui/material/colors';

interface ETADialogProps {
  disabled?: boolean;
  accepting?: boolean;
  onAccept: (minutes: number) => void;
}

const ETADialog = (props: ETADialogProps) => {
  const [open, setOpen] = React.useState(false);
  const [eta, setETA] = React.useState<string>('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeEta = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setETA(evt.target.value);
  };

  const handleAccept = () => {
    if (eta) {
      props.onAccept(parseInt(eta));
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClickOpen}
        disabled={props.disabled}
        sx={{
          color: green[500],
          backgroundColor: 'white',
          border: `1px solid ${green[500]}`,
          boxShadow: 'none',
          marginRight: 1,
          height: 60,
          '&:hover': {
            backgroundColor: green[700],
            color: 'white'
          }
        }}
      >
        Other
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Accept for minutes after requested for time
        </DialogTitle>
        <DialogContent style={{ width: 300 }}>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            type="number"
            value={eta}
            onChange={onChangeEta}
            label="Enter minutes"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAccept} color="primary">
            {props.accepting ? <CircularProgress size={12} /> : 'Accept'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ETADialog;
